import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  curMgr: null,
  usersCur: [],
  localUser: {},
  radarViewMgr: null,
  cursorState: [],
  lineOwner: null,
  cursor: true,
  radar: true,
  lineOwn: true,
};

export const cursorSlice = createSlice({
  name: 'curMag',
  initialState,
  reducers: {
    updateCurMag: (state, action) => {
      // console.log(action.payload);
      state.curMgr = action.payload;
    },
    updateUserCur: (state, action) => {
      // console.log(action.payload);
      state.usersCur.push(action.payload);
    },

    replaceAllCur: (state, action) => {
      // console.log(action.payload);
      state.usersCur = action.payload;
    },

    setLocalUsers: (state, action) => {
      // console.log(action.payload);
      state.localUser = action.payload;
    },

    setRadarView: (state, action) => {
      // console.log(action.payload);
      state.radarViewMgr = action.payload;
    },

    setCursorState: (state, action) => {
      // console.log(action.payload);
      state.cursorState = action.payload;
    },

    setLinerOwner: (state, action) => {
      // console.log(action.payload);
      state.lineOwner = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateCurMag,
  updateUserCur,
  replaceAllCur,
  setLocalUsers,
  setRadarView,
  setCursorState,
  setLinerOwner,
} = cursorSlice.actions;

export const curMag = (state) => state.curMag.curMgr;
export const userCur = (state) => state.curMag.usersCur;
export const localUsers = (state) => state.curMag.localUser;
export const radarViewMgr = (state) => state.curMag.radarViewMgr;
export const lineOwner = (state) => state.curMag.lineOwner;

export const cursorState = (state) => state.curMag.cursorState;

export default cursorSlice.reducer;
